<div class="info_container no-padding" *ngIf="message">
   <p class="info_message" *ngIf="message.title"> {{message.title}} </p>
   <i class="info" *ngIf="message.detail">{{message.detail}}</i>
</div>